<template>
  <div class="container">
    <!-- 使用 Element Plus 布局组件实现按钮居中 -->
    <el-row justify="center" style="margin-bottom: 20px;">
      <!-- 点击显示柱状图 -->
      <el-button type="primary" @click="showBarChart">柱状图</el-button>
      <!-- 点击显示饼状图 -->
      <el-button type="success" @click="showPieChart">饼状图</el-button>
    </el-row>
    <!-- 图表容器 -->
    <div id="chart" style="width: 100%; height: 400px;"></div>
  </div>
</template>

<script>
// 导入 ECharts
import * as echarts from "echarts";

export default {
  data() {
    return {
      chart: null, // 图表实例
      chartData: [
        // 图表使用的数据，包含名称和对应值
        { name: "类型A", value: 40 },
        { name: "类型B", value: 25 },
        { name: "类型C", value: 35 },
      ],
    };
  },
  mounted() {
    // 在组件挂载后初始化 ECharts 实例
    this.chart = echarts.init(document.getElementById("chart"));
    // 默认显示柱状图
    this.showBarChart();
  },
  methods: {
    // 显示柱状图的方法
    showBarChart() {
      // 配置柱状图的选项
      const option = {
        title: {
          text: "柱状图示例", // 图表标题
          left: "center", // 标题居中
        },
        tooltip: {
          trigger: "axis", // 提示框触发方式：坐标轴触发
        },
        xAxis: {
          type: "category", // X 轴为类目轴
          data: this.chartData.map((item) => item.name), // 设置 X 轴数据为图表的名称
        },
        yAxis: {
          type: "value", // Y 轴为数值轴
        },
        series: [
          {
            name: "数量", // 系列名称
            type: "bar", // 图表类型为柱状图
            data: this.chartData.map((item) => item.value), // 数据来源为图表的值
            itemStyle: {
              color: "#409EFF", // 柱状图颜色
            },
          },
        ],
      };
      // 将配置应用到图表实例
      this.chart.setOption(option);
    },
    // 显示饼状图的方法
    showPieChart() {
      // 配置饼状图的选项
      const option = {
        title: {
          text: "饼状图示例", // 图表标题
          left: "center", // 标题居中
        },
        tooltip: {
          trigger: "item", // 提示框触发方式：数据项触发
          formatter: "{a} <br/>{b}: {c} ({d}%)", // 提示框显示格式
        },
        series: [
          {
            name: "数量分布", // 系列名称
            type: "pie", // 图表类型为饼状图
            radius: "50%", // 饼图半径大小
            data: this.chartData, // 数据来源
            emphasis: {
              // 高亮样式
              itemStyle: {
                shadowBlur: 10, // 阴影模糊度
                shadowOffsetX: 0, // 阴影水平偏移
                shadowColor: "rgba(0, 0, 0, 0.5)", // 阴影颜色
              },
            },
          },
        ],
      };
      // 将配置应用到图表实例
      this.chart.setOption(option);
    },
  },
};
</script>

<style scoped>
/* 容器样式 */
.container {
  width: 80%; /* 容器宽度 */
  margin: auto; /* 水平居中 */
  padding: 20px; /* 内边距 */
  text-align: center; /* 内容居中对齐 */
}
</style>
